
import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';
import { Toast, Image } from 'vant';
import { constructionScopeType, mainTypes } from '@/interfaces/virtualTeachingAndResearchSectionCommonType';
import virtualTeachingApi from '@/apis/virtualTeachingAndResearchOffice';
import TeachingInfo from './components/teachingInfo.vue';
import TopicGoal from './components/topicGoal.vue';
import Announcement from './components/announcement.vue';
import SharePage from '@/components/VirtualTeachingAndResearchOffice/sharePage/index.vue';
import i18n from '@/lang';

@Component({
  name: 'TeachingMain',
  components: {
    TeachingInfo,
    TopicGoal,
    Announcement,
    SharePage,
  },
})
export default class TeachingMain extends Vue {
  scopeType = constructionScopeType;
  mainTypes = mainTypes;
  private resourceId: string = '';
  private showInfoDailog: boolean = false;
  private showTopicGoal: boolean = false;
  private showAnnounce: boolean = false;
  private showSharePage: boolean = false;
  private bulletinText: string = '';
  private tabsActive: string = '/teachingMain/discussionActivities';
  private menuList = [
    {
      value: '1',
      label: '动态',
      path: '/teachingMain/dynamicState',
    },
    {
      value: '2',
      label: '活动',
      path: '/teachingMain/discussionActivities',
    },
    {
      value: '3',
      label: '资源库',
      path: '/teachingMain/resource',
    },
    {
      value: '4',
      label: '样板课程',
      path: '/teachingMain/samplePlateCourse',
    },
  ];
  private shareParams: any = {};
  get officeDetails() {
    return this.$store.state.officeDetails;
  }
  @Watch('$route')
  onchangeRoute() {
    this.tabsActive = this.$route.path;
  }
  created() {
    this.resourceId = this.$route.query.resourceId as string;
    this.init();
  }
  getOfficeDetails() {
    this.$store.dispatch('setOfficeDetails', this.resourceId);
  }
  init() {
    this.tabsActive = this.$route.path;
    this.getOfficeDetails();
    this.getNotify('get');
  }
  goBackList() {
    this.$router.push({ path: '/teachingAndResearchOffice' });
  }
  handleClick(path: string) {
    if (path != this.$route.path) {
      this.$router.replace({
        path: path,
        query: this.$route.query,
      });
    }
  }
  //获取编辑公告板
  getNotify(type: string, data?: string) {
    let params = {
      resourceid: this.resourceId,
      type: type,
      content: data ? data : '',
    };
    virtualTeachingApi.getNotify(params).then((res: any) => {
      this.bulletinText = res.content;
      if (type == 'save') {
        this.$toast(i18n.t('Home.编辑成功'));
      }
    });
  }
  //打开分享
  openSharePage() {
    this.shareParams = {
       resourceId: this.resourceId,
        showType: 'office',
    }
    this.showSharePage = true;
  }
}
